import { useEffect } from "react"
import { useAppDispatch } from "redux/store"
import { useTranslation } from "react-i18next"
import BreadCrumb from "components/bread-crumb"
import { getAllProjectsAction } from "redux/comparator/middleware"
import { resetComparatorData } from "redux/comparator/iftComparatorSlice"
import useDocumentTitle from "hooks/useDocumentTitle"
import IFTComparatorLevelHeader from "./components/iftComparatorHeader"
import IFTComparatorLevelLoader from "./components/iftComparatorLoaderScreen"
import IFTComparatorLevelTable from "./components/iftCompratorTable"
import { iftLevelBreadCrumb } from "./utils"
import "./ift-comparator.scss"

const IFTComp: React.FC = (): JSX.Element => {
  useDocumentTitle("Cost Element Comparator | Cost and Carbon Forecasting tool")
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getAllProjectsAction())
    dispatch(resetComparatorData())
  }, [])

  return (
    <div className="iftLevelMain">
      <IFTComparatorLevelLoader />
      <BreadCrumb data={iftLevelBreadCrumb(t)} />
      <IFTComparatorLevelHeader />
      <IFTComparatorLevelTable />
    </div>
  )
}

export default IFTComp
